import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const editCommissionBox: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.remSize[300]};
  z-index: ${theme.zIndex.overlay};
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${theme.color.background.neutral.default.lowest};
`;

export const addCommissionBox: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: ${theme.remSize[300]};
`;

export const commissionForm = () => css`
  flex-grow: 1;
`;
